import React from 'react'
import CoverSection from 'app/React/InspirationUniverse/CoverSection'
import Products from 'app/React/InspirationUniverse/Products'

export default function InspirationUniverseContent () {
  return (
    <>
      <CoverSection/>
      <Products/>
    </>
  )
}
